"use strict";
import axios from '@frontend/js/utils/axios';

var KTSubmitGeneral = function () {
    var form;
    var submitButton;
    var validator;

    var handleValidation = function (e) {
        validator = FormValidation.formValidation(
            form,
            {
                fields: {
                    'username': {
                        validators: {
                            notEmpty: {
                                    message: validationMessages.username_required,
                                }
                            }
                    },
                },
                plugins: {
                    trigger: new FormValidation.plugins.Trigger(),
                    bootstrap: new FormValidation.plugins.Bootstrap5({
                        rowSelector: '.fv-row',
                        eleInvalidClass: '',  // comment to enable invalid state icons
                        eleValidClass: '' // comment to enable valid state icons
                    })
                }
            }
        );
    }

    var handleSubmit = function (e) {
        submitButton.addEventListener('click', function (e) {
            e.preventDefault();

            validator.validate().then(function (status) {
                if (status == 'Valid') {
                    const requestData = {
                        username: document.querySelector('[name=username]').value,
                    };

                    axios.post(
                        authUrl,
                        requestData,
                    ).then(function (response) {
                        console.log(response);
                        if(response.status === true) {
                            submitButton.setAttribute('data-kt-indicator', 'on');
                            submitButton.disabled = true;

                            form.submit();
                        } else {
                            toastr.error(validationMessages.username_not_exists);
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                }
            });
        });
    }

    return {
        init: function () {
            form = document.querySelector('#kt_forgot_password_form');
            submitButton = document.querySelector('#kt_forgot_password_submit');
            handleValidation();
            handleSubmit();
        }
    };
}();

KTUtil.onDOMContentLoaded(function () {
    KTSubmitGeneral.init();
});
